module.exports = __webpack_public_path__ + "static/img/404_cloud.png";